var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sceneFlyover } from "./utils/sceneFlyover";
import { defaultRendererConfig } from "./index";
export function layeredImageryFlyover2(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Layered Imagery Flyover 2" +
                "</h1>" +
                "<p>" +
                "The camera will fly over the globe with a specific layered imagery source. The globe should render normally." +
                "</p>";
        const initialWait = 5;
        const time = 3;
        const DURATIONS = [0, initialWait, time, time, time];
        const POSITIONS = [
            { longitude: -1.996376342320494, latitude: 0.893167672424946, height: 29388.567819065174 },
            { longitude: -1.996376342320494, latitude: 0.893167672424946, height: 29388.567819065174 },
            { longitude: -1.9952380989933949, latitude: 0.8933756974973185, height: 229.70783053572862 },
            { longitude: -1.9952402164688696, latitude: 0.8933835433762363, height: 11.152951583862151 },
            { longitude: -1.995243777501573, latitude: 0.8933714329473799, height: 3.1148975012243945 },
        ];
        const FOCUSES = [
            { longitude: -1.9952202281601934, latitude: 0.8933813720679386, height: 2.0773781174828616 },
            { longitude: -1.9952202281601934, latitude: 0.8933813720679386, height: 2.0773781174828616 },
            { longitude: -1.9952202281601934, latitude: 0.8933813720679386, height: 2.0773781174828616 },
            { longitude: -1.995241023897113, latitude: 0.8933826490897232, height: 0.6125991644472061 },
            { longitude: -1.9952423535511332, latitude: 0.8933720831835373, height: 0.21312241514294472 },
        ];
        yield sceneFlyover(defaultRendererConfig(container), DURATIONS, POSITIONS, FOCUSES, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Intentionally dropped promise, blocking is not needed
            const _ = renderer
                .getWorld()
                .getGlobe()
                .setTileLayers([
                {
                    type: "osm",
                },
                {
                    type: "cesium",
                    assetId: 678504,
                },
            ]);
        }));
    });
}
